/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useFormContext } from "react-hook-form";
import { KeyIcon } from "@heroicons/react/24/outline";
import ErrorMessage from "components/atoms/forms/ErrorMessage";
import { UserProfileSettingForm } from "pages/UserSettings";

function UserChangePasswordForm() {
  const {
    register,
    formState: { errors },
  } = useFormContext<UserProfileSettingForm>();

  return (
    <div className="mt-4 grid grid-cols-10 gap-x-4  gap-y-2 font-satoshi md:gap-x-12">
      <div className="col-span-10 mb-2 flex items-center gap-1.5">
        <KeyIcon className="h-6 w-6 text-secondary" />
        <p className="font-satoshi text-sm font-black text-white opacity-90">Change Password</p>
      </div>
      <div className="col-span-10  md:col-span-6">
        <div>
          <label htmlFor="password" className="block text-sm font-semibold leading-6 text-neutral-200">
            Old Password
          </label>
          <div className="mt-1">
            <input
              {...register("old_password")}
              placeholder="Enter old password"
              id="old_password"
              name="old_password"
              type="password"
              required
              className="block w-full rounded-md border-0 bg-white bg-opacity-5 py-4 pl-3.5 font-medium text-neutral-200 shadow-sm ring-2 ring-inset ring-white ring-opacity-5 placeholder:text-neutral-500 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
            />
          </div>
          <ErrorMessage errorMessage={errors?.old_password?.message} />
        </div>
      </div>
      <div className=" col-span-10 md:col-span-6">
        <label htmlFor="password" className="block text-sm font-semibold leading-6 text-neutral-200">
          New Password
        </label>
        <div className="mt-1">
          <input
            {...register("new_password")}
            placeholder="Enter new password"
            id="new_password"
            name="new_password"
            type="password"
            required
            className="block w-full rounded-md border-0 bg-white bg-opacity-5 py-4 pl-3.5 font-medium text-neutral-200 shadow-sm ring-2 ring-inset ring-white ring-opacity-5 placeholder:text-neutral-500 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
          />
        </div>
        <ErrorMessage errorMessage={errors?.new_password?.message} />
      </div>
      <div className="col-span-10 md:col-span-6">
        <label htmlFor="password" className="block text-sm font-semibold leading-6 text-neutral-200">
          Confirm New Password
        </label>
        <div className="mt-1">
          <input
            {...register("confirm_new_password")}
            placeholder="Confirm new password"
            id="confirm_new_password"
            name="confirm_new_password"
            type="password"
            required
            className="block w-full rounded-md border-0 bg-white bg-opacity-5 py-4 pl-3.5 font-medium text-neutral-200 shadow-sm ring-2 ring-inset ring-white ring-opacity-5 placeholder:text-neutral-500 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
          />
        </div>
        <ErrorMessage errorMessage={errors?.confirm_new_password?.message} />
      </div>
    </div>
  );
}
export default UserChangePasswordForm;

UserChangePasswordForm.defaultProps = {
  isOnboard: true,
};
